import { padding, useClassnames } from '@lumapps/classnames';
import { Typography } from '@lumapps/lumx/react';

export interface UseFilterUIProps {
    /** Additional class name for the component */
    className?: string;
    /** Parent class name for the component */
    parentClassName: string;
}

export const useFilterUIProps = ({ className, parentClassName }: UseFilterUIProps) => {
    const { block } = useClassnames(parentClassName);

    return {
        className: block([className, padding('all', null)]),
        typography: Typography.subtitle1,
    };
};
